<template>
  <div v-if="activeVenue" id="dashboard-analytics">
    <h4 class="mb-8">Powerbi Tester</h4>
    <h5 class="mb-2">Report filter</h5>
    <p>Report identifiers</p>
    <vs-row>
      <vs-input
        class="inputx mr-4"
        label="Workspace ID"
        placeholder="Report workspace"
        v-model="reportWorkspace"
      />
      <vs-input
        class="inputx mr-4"
        label="Report ID"
        placeholder="Report ID"
        v-model="reportId"
      />

      <vs-button @click="loadReport" color="primary" type="filled" class=""
        >Load report</vs-button
      > </vs-row
    ><br /><br />
    <vs-row>
      <vs-input
        class="inputx mr-4"
        label="Table"
        placeholder="Table name"
        v-model="filterTable"
      />
      <vs-input
        class="inputx mr-4"
        label="Column"
        placeholder="Column name"
        v-model="filterColumn"
      />
      <vs-select label="Operator" v-model="operator">
        <vs-select-item
          :key="index"
          :value="item"
          :text="item"
          v-for="(item, index) in operators"
        />
      </vs-select>
      <vs-input
        class="inputx mr-4"
        label="Filter value"
        placeholder="Filter value"
        v-model="filterValue"
      />
      <vs-button @click="applyFilter" color="primary" type="filled" class=""
        >Apply</vs-button
      >
    </vs-row>
    <div class="vx-row">
      <div class="vx-col w-full mb-base" id="root">
        <section
          style="width: 90%; padding-right: 50px; height: 100%"
          id="report-container"
          class="
            embed-container
            col-lg-offset-4
            col-lg-7
            col-md-offset-5
            col-md-7
            col-sm-offset-5
            col-sm-7
            mt-5
          "
        ></section>
        <!-- Used to display report embed error messages -->
        <section class="error-container m-5"></section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
//import * as powerbi from 'powerbi-client';
export default {
  data() {
    return {
      reportWorkspace: "",
      reportId: "",
      operators: ["In", "Eq"],
      operator: "In",
      filterTable: "",
      filterColumn: "",
      filterValue: "",
      report: null,
    };
  },
  components: {},
  methods: {
    async loadReport() {
      this.$vs.loading();
      await this.$store.dispatch("powerBi/getReportDetails", {
        reportId: this.reportId,
        workspaceId: this.reportWorkspace,
      });

      console.log("Got report details: ", this.reportDetails);
      let reportContainer = document.getElementById("report-container");

      //let powerbi = window["powerbi-client"];
      let models = window["powerbi-client"].models;

      powerbi.bootstrap(reportContainer, { type: "report" }); // eslint-disable-line
      const embedData = this.reportDetails;

      let pageSize = {
        type: models.PageSizeType.Custom,
        width: 300,
        height: 580,
      };

      // Create a config object with type of the object, Embed details and Token Type
      let reportLoadConfig = {
        type: "report",
        tokenType: models.TokenType.Embed,
        accessToken: embedData.EmbedToken.Token,

        embedUrl: embedData.EmbedReport[0].EmbedUrl,

        // Enable this setting to remove gray shoulders from embedded report
        settings: {
          background: models.BackgroundType.Transparent,
          layoutType: models.LayoutType.Custom,
          pageSize: pageSize,
          customLayout: {
            //pageSize: pageSize,
            displayOption: models.DisplayOption.FitToWidth, // FitToWidth
          },
        },
      };

      console.log("Powerbi config", reportLoadConfig);

      // Use the token expiry to regenerate Embed token for seamless end user experience
      // Refer https://aka.ms/RefreshEmbedToken
      const tokenExpiry = embedData.EmbedToken.Expiration;

      // Embed Power BI report when Access token and Embed URL are available
      this.report = powerbi.embed(reportContainer, reportLoadConfig); // eslint-disable-line

      // Clear any other loaded handler events
      this.report.off("loaded");

      // Triggers when a report schema is successfully loaded
      this.report.on("loaded", function () {
        console.log("Report load successful");
      });

      // Clear any other rendered handler events
      this.report.off("rendered");

      // Triggers when a report is successfully embedded in UI
      this.report.on("rendered", function () {
        console.log("Report render successful");
      });

      // Clear any other error handler events
      this.report.off("error");

      // Handle embed errors
      this.report.on("error", function (event) {
        let errorMsg = event.detail;
        console.error(errorMsg);
        return;
      });

      this.$vs.loading.close();
    },
    async applyFilter() {
      console.log("Applying filters");
      //      const filt = ([148640, 158970, 11017, 14177, 13521, 161]).map(e => "" + e);

      /*if(this.operator === "In") {
        this.filterValue = this.filterValue.split(",").map(e => e.trim())
      }*/

      let models = window["powerbi-client"].models;
      const filter = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
          table: this.filterTable,
          column: this.filterColumn,
        },
        operator: this.operator,
        values: this.filterValue,
      };

      // Add the filter to the report's filters.
      try {
        await this.report.updateFilters(models.FiltersOperations.Replace, [
          filter,
        ]); // Add
        console.log("Report filter was added.");
      } catch (errors) {
        console.log(errors);
      }
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      reportDetails: "powerBi/reportDetails",
    }),
  },
  async mounted() {},
};
</script>

<style lang="scss">
/* iframe's parent node */
div#root {
  position: fixed;
  width: 80%;
  height: 80%;
}

/* iframe itself */
div#root > iframe {
  display: block;
  width: 80%;
  height: 100%;
  border: none;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
